module.exports = __webpack_public_path__ + "img/category.491b9961.svg";